import { directoryLogoPath, defaultLogoPath, mapBrands } from './BrandMapping'

const classNamePage: string = 'page-job-details'
const classNameContainerInformation: string = `${classNamePage}__container-information`
const classNameBrandLogo: string = `${classNamePage}__brand-logo`

export const initialise = () => {
    const page = document.body.classList.contains(classNamePage)
    if (!page) return

    createLogoContainer()
    updateLogo()
}

const createLogoContainer = () => {
    const container = document.querySelector<HTMLDivElement>(`.${classNameContainerInformation} > .container-col`)
    if (!container) return

    let logo: HTMLImageElement = document.createElement('img')
    logo.classList.add(classNameBrandLogo)
    logo.alt = ''
    logo.width = 350
    logo.height = 40
    logo.loading = 'lazy'
    logo.src = defaultLogoPath
    container.prepend(logo)
}

const updateLogo = () => {
    mapBrands.forEach((fileType: string, fileName: string) => {
        const fileNameClean: string = fileName.replace(/-/g, '')
        const brandClass: string = `brand-${fileNameClean}`

        if (document.body.classList.contains(brandClass)) {
            let brandFileName: string = `${fileName}.${fileType}`
            const filePath: string = `${directoryLogoPath}/${brandFileName}`

            const logo = document.querySelector<HTMLImageElement>(`.${classNameBrandLogo}`)
            if (!logo) return
            logo.src = filePath
        }
    })
}